var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Bag-Dollar--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Bag Dollar Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag-dollar--bag-payment-cash-money-finance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffe70d",
    fillRule: "evenodd",
    d: "M13.463 9.692C13.463 12.664 10.77 14 7 14S0.537 12.664 0.537 9.713c0 -3.231 1.616 -4.868 4.847 -6.505L4.24 1.077A0.7 0.7 0 0 1 4.843 0H9.41a0.7 0.7 0 0 1 0.603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484ZM7.625 4.887a0.625 0.625 0 1 0 -1.25 0v0.627a1.74 1.74 0 0 0 -0.298 3.44l1.473 0.322a0.625 0.625 0 0 1 -0.133 1.236h-0.834a0.625 0.625 0 0 1 -0.59 -0.416 0.625 0.625 0 1 0 -1.178 0.416 1.877 1.877 0 0 0 1.56 1.239v0.636a0.625 0.625 0 1 0 1.25 0v-0.636a1.876 1.876 0 0 0 0.192 -3.696l-1.473 -0.322a0.49 0.49 0 0 1 0.105 -0.97h0.968a0.622 0.622 0 0 1 0.59 0.416 0.625 0.625 0 0 0 1.178 -0.417 1.874 1.874 0 0 0 -1.56 -1.238v-0.637Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagDollarIcon);
export default __webpack_public_path__ + "static/media/bag-dollar-icon.f88e202a73754ef78de6e12bc76e0662.svg";
export { ForwardRef as ReactComponent };